import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from '@tradera/blueprint/theme/icons2/arrow-down.svg?jsx';
import { Button } from 'tradera-components/atoms/button/button';

const AccordionItem = ({
    className = '',
    collapsable = true,
    hideTitle = false,
    icon,
    defaultOpen,
    label,
    onChange,
    render,
    title
}) => {
    const [accordionOpen, setAccordionOpen] = useState(defaultOpen);

    return (
        <div className={`accordion-item my-1 ${className}`}>
            {hideTitle ? (
                <div className="item-body">{render()}</div>
            ) : (
                <>
                    <Button
                        unbutton
                        className={`d-flex align-items-center py-2 text-left px-1 ${
                            collapsable ? 'cursor-pointer' : ''
                        }`}
                        onClick={
                            collapsable
                                ? () => {
                                      setAccordionOpen(!accordionOpen);
                                      if (onChange) {
                                          onChange(!accordionOpen); // send in the new value
                                      }
                                  }
                                : null
                        }>
                        {icon && (
                            <span className="d-flex mr-1 flex-grow-0 flex-shrink-0">
                                {icon}
                            </span>
                        )}
                        <span
                            className={`text-styled accordion-text ${
                                accordionOpen ? 'font-weight-bold' : ''
                            } flex-grow-1 flex-shrink-1`}>
                            {title}
                        </span>
                        <span className="ml-auto d-block">
                            {label && (
                                <span className="flex-grow-0 flex-shrink-0">
                                    {label}
                                </span>
                            )}
                            {collapsable && (
                                <span
                                    className={`arrow ${
                                        accordionOpen ? 'open' : ''
                                    } flex-grow-0 flex-shrink-0`}>
                                    <ArrowIcon className="icon icon-sm icon-dark" />
                                </span>
                            )}
                        </span>
                    </Button>
                    <div
                        className={`item-body px-2 ${
                            accordionOpen ? '' : 'collapsed'
                        }`}>
                        <div className="pb-1">{render()}</div>
                    </div>
                </>
            )}
        </div>
    );
};

AccordionItem.propTypes = {
    className: PropTypes.string,
    collapsable: PropTypes.bool,
    hideTitle: PropTypes.bool,
    icon: PropTypes.node,
    defaultOpen: PropTypes.bool,
    label: PropTypes.node,
    onChange: PropTypes.func,
    render: PropTypes.func.isRequired,
    title: PropTypes.string
};

export default AccordionItem;
